import { forwardRef } from "react";
import mission from "../assets/target.png"
import "./styles.css"

const About = forwardRef((props, ref) => (
    <div ref={ref} className="container-banner">
        <div className="inner-container">
            <div className="text-container">
                <h2 className="missonHeading">Our Mission</h2>
                Our mission is simple: to close the gap between classroom learning and real-world experience. We believe that all students deserve quality internship opportunities and educational resources that will help them succeed in their studies and careers.
            </div>
            {/* <button className="get-started-btn" onClick={handleClick}>Get Started</button> */}
        </div>
        <div className="image-container">
            <img src={mission} alt="#" />
        </div>
    </div>
));

export default About